export default "__VITE_ASSET__DBTxnr7j__"